<div class="presentation-video-wrapper">
  <div
    class="presentation-video-list"
    [ngClass]="['presenters-count-' + presentersCount(), isMobile() ? 'mobile' : '']"
  >
    <!-- TODO: figure out why this isn't working to enable nth-child styling, add *ngIf="slots[i].inUse" to div -->
    @for (slot of [1, 2, 3, 4]; track slot; let i = $index) {
      <div
        class="presentation-video-instance"
        [ngClass]="{
          'in-use': getSlotItem(i).inUse && !getSlotItem(i).videoMuted,
          'local-presenter': getSlotItem(i).isLocal,
          muted: getSlotItem(i).videoMuted,
        }"
        [hidden]="!getSlotItem(i).inUse || (activeSlots() > 1 && getSlotItem(i).videoMuted)"
      >
        <div class="video-instance-border">
          @if (getSlotItem(i).emote) {
            <div class="presenter-emote">
              <span class="emote-text">{{ getSlotItem(i).emote?.native ?? '' }}</span>
            </div>
          }
          <video
            #presenter
            [attr.data-presenterid]="'presenter' + (i + 1)"
            (click)="toggleVideoDrawer($event)"
            [ngClass]="{ 'popped-out': clickedPresenter() === i }"
          ></video>
          @if (getSlotItem(i).videoMuted && presentersDrawerOpen) {
            <img
              alt="video off"
              src="assets/images/video_off.svg"
              class="mute-indicator"
              (click)="toggleVideoDrawer($event)"
            />
          }
          @if (presentersDrawerOpen && roomHasRingColors() && getSlotItem(i).ringColor) {
            <app-ring-colors-legend [ringContainerPosition]="{ left: '8px', top: '36px' }">
              <ng-container>
                <div class="visual-indicator">
                  <div class="legend-dot" style="--color: {{ getSlotItem(i).ringColor }}"></div>
                </div>
              </ng-container>
            </app-ring-colors-legend>
          }
          @if (getSlotItem(i).audioMuted && presentersDrawerOpen) {
            <div class="audio-muted-indicator" [ngClass]="{ audio_hover: popOutVideo() && presentersDrawerOpen }">
              <mat-icon>mic_off</mat-icon>
            </div>
          }
          @if (popOutVideo() && presentersDrawerOpen && !getSlotItem(i).videoMuted) {
            <div
              [ngClass]="{
                'presenter-popout': !isPresenterPopout(),
                'presenter-in-popout': isPresenterPopout() && clickedPresenter() === i,
              }"
            >
              <app-presentation-popout-button
                [videoElementToPopOut]="presenter"
                [mode]="'PRESENTER'"
                (startedPopout)="clickedPresenter.set(i)"
                (endedPopout)="clickedPresenter.set(null)"
              ></app-presentation-popout-button>
            </div>
          }
          @if (
            getSlotItem(i).name &&
            getSlotItem(i).userId &&
            getSlotItem(i).inUse &&
            !getSlotItem(i).isLiveStream &&
            presentersDrawerOpen
          ) {
            <div
              class="presenters-info"
              role="button"
              aria-label="Presenter's name"
              [ngClass]="{
                'presenters-name-gallery-open': isGalleryDrawerOpen,
                'presenters-name-gallery-open-sharing': isGalleryDrawerOpen && isSharingScreen,
                'presenters-name-sharing-screen': !isGalleryDrawerOpen && isSharingScreen,
              }"
            >
              @if (!getSlotItem(i).isLocal) {
                <div
                  class="presenters-favorite"
                  [ngClass]="{ 'presenters-favorite-visible': getSlotItem(i).isFavorite }"
                  role="button"
                  (click)="addOrRemoveFavorite(getSlotItem(i))"
                >
                  @if (getSlotItem(i).isFavorite) {
                    <mat-icon>star</mat-icon>
                  }
                  @if (!getSlotItem(i).isFavorite) {
                    <mat-icon>star_outline</mat-icon>
                  }
                </div>
              }
              <div
                class="presenters-name-wrapper"
                title="{{ formatPresentersName(getSlotItem(i)) }}"
                role="button"
                (click)="openBadge(getSlotItem(i).userId)"
              >
                <span>
                  {{ formatPresentersName(getSlotItem(i)) }}
                </span>
                <mat-icon [ngClass]="{ 'icon-presenters-size': !isGalleryDrawerOpen && isSharingScreen }">
                  info
                </mat-icon>
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (!isUserPresenting() && presentationMyGroupV1()) {
      <app-presentation-thumbprint
        class="thumbprint"
        [canClose]="!isSharingScreen"
        [type]="thumbprintType"
        [open]="presentersDrawerOpen"
        [isPresenter]="isUserPresenting()"
      ></app-presentation-thumbprint>
    }

    @if (isSharingScreen && !isMobile()) {
      <button
        title="Open video drawer"
        type="button"
        class="drawer-button"
        (click)="toggleVideoDrawer($event)"
        [matTooltip]="collapseDrawerButtonText"
        matTooltipPosition="left"
      >
        <mat-icon>
          {{ presentersDrawerOpen ? 'arrow_forward_ios' : 'arrow_back_ios' }}
        </mat-icon>
      </button>
    }
  </div>
</div>
